/**
 * Ekselens — site-wide configurable facts. Edit values here when you have them.
 *
 * Any field set to null is HIDDEN automatically (it won't appear on the site).
 * Once you have a value, replace the null with a string.
 */
export const BRAND = {
  companyName: "Ekselens Consulting",
  legalName: "Ekselens Limited",
  companyNumber: "15750277",
  vatNumber: "GB 468 4026 76",
  icoRegistration: "ZB907517",
  yearFounded: "2024",
  registeredAddress:
    "5th Floor, 167-169 Great Portland Street, London, W1W 5PF",
  linkedinUrl: "https://www.linkedin.com/company/113256920/",
  linkedinLabel: "Follow Ekselens Consulting on LinkedIn",
};
